class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    this.initializeFeatures();
    this.variantChangeHandler = this.handleVariantChange.bind(this);
    document.addEventListener("variant:changed", this.variantChangeHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.variantChangeHandler);
    this.features?.forEach((item) => {
      item
        .querySelector("button")
        ?.removeEventListener("click", this.handleFeatureClick);
    });
  }

  initializeFeatures() {
    this.features = this.querySelectorAll(".feature-block");
    this.handleFeatureClick = this.onFeatureClick.bind(this);

    this.features.forEach((item) => {
      item
        .querySelector("button")
        ?.addEventListener("click", this.handleFeatureClick);
    });
  }

  handleVariantChange(event) {
    const variant = event.detail;
    if (!variant) return;

    // Store current expanded states
    const expandedStates = new Map();
    this.features.forEach((feature) => {
      const button = feature.querySelector("button");
      if (button) {
        expandedStates.set(
          feature.querySelector("span")?.textContent?.trim(),
          button.getAttribute("aria-expanded") === "true",
        );
      }
    });

    // Fetch updated content
    fetch(
      `${window.location.pathname}?variant=${variant.id}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newFeatures = html.querySelector("product-features");
        if (newFeatures) {
          this.innerHTML = newFeatures.innerHTML;
          this.initializeFeatures();

          // Restore expanded states
          this.features.forEach((feature) => {
            const title = feature.querySelector("span")?.textContent?.trim();
            if (title && expandedStates.get(title)) {
              const button = feature.querySelector("button");
              const content = feature.querySelector(".feature-content");
              const icon = feature.querySelector(".feature-icon");

              if (button && content && icon) {
                button.setAttribute("aria-expanded", "true");
                content.classList.remove("hidden");
                icon.classList.remove("fa-plus");
                icon.classList.add("fa-minus");
              }
            }
          });
        }
      })
      .catch((error) =>
        console.error("Error updating product features:", error),
      );
  }

  toggleFeature(el) {
    let content = el
      .closest(".feature-block")
      .querySelector(".feature-content");

    let icon = el.closest(".feature-block").querySelector(".feature-icon");

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden");
      icon.classList.remove("fa-plus");
      icon.classList.add("fa-minus");
      el.setAttribute("aria-expanded", "true");
    } else {
      content.classList.add("hidden");
      icon.classList.add("fa-plus");
      icon.classList.remove("fa-minus");
      el.setAttribute("aria-expanded", "false");
    }
  }

  onFeatureClick(evt) {
    const target = evt.target;
    this.toggleFeature(target);
  }
}

customElements.define("product-features", ProductFeatures);
